import { IDataStorage } from '../internal/data-storage';
import { InternalTable } from '../internal/internal-table';

export class Theme implements IDataStorage {
  tableDefinition: InternalTable = new InternalTable('Theme', 'Id', true, []);

  name: string;

  constructor(name?: string) {
    if (name) {
      this.name = name;
    }
  }

  static getTableDefinition(): InternalTable {
    return new Theme().tableDefinition;
  }
}
